var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 25,
    viewBox: "0 0 34 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payment method icon"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "visa-logo",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7503 16.3579H8.69051L7.14596 10.292C7.07265 10.013 6.91699 9.76627 6.68802 9.65001C6.11659 9.35784 5.48692 9.12531 4.8 9.00804V8.7745H8.11808C8.57603 8.7745 8.91948 9.12531 8.97673 9.53274L9.77813 13.9083L11.8369 8.7745H13.8394L10.7503 16.3579ZM14.9842 16.3579H13.039L14.6408 8.7745H16.586L14.9842 16.3579ZM19.1027 10.8753C19.1599 10.4669 19.5034 10.2334 19.9041 10.2334C20.5338 10.1747 21.2197 10.292 21.7921 10.5832L22.1356 8.95042C21.5631 8.71688 20.9335 8.59961 20.362 8.59961C18.474 8.59961 17.1002 9.65002 17.1002 11.1078C17.1002 12.2169 18.0733 12.7992 18.7603 13.15C19.5034 13.4998 19.7896 13.7334 19.7324 14.0832C19.7324 14.6079 19.1599 14.8414 18.5885 14.8414C17.9016 14.8414 17.2147 14.6665 16.586 14.3743L16.2426 16.0081C16.9295 16.2992 17.6726 16.4165 18.3596 16.4165C20.4765 16.4741 21.7921 15.4247 21.7921 13.8496C21.7921 11.8661 19.1027 11.7498 19.1027 10.8753ZM28.6 16.3579L27.0554 8.7745H25.3964C25.0529 8.7745 24.7095 9.00804 24.595 9.35784L21.7349 16.3579H23.7374L24.1371 15.2498H26.5975L26.8265 16.3579H28.6ZM25.6826 10.8167L26.254 13.6747H24.6523L25.6826 10.8167Z",
    fill: "#172B85"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 33,
    height: 23,
    rx: 3.5,
    stroke: "#F2F4F7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.ef8e80a6f43a5fec0603149c6607503b.svg";
export { ForwardRef as ReactComponent };